import { Typography } from 'antd';
import { BookOutlined } from '@ant-design/icons';

const { Title, Text } = Typography;

/** 图书管理页面（占位，后续需求实现 CRUD） */
export default function BooksPage() {
  return (
    <div>
      <Title level={3}>
        <BookOutlined /> 图书管理
      </Title>
      <Text type="secondary">图书 CRUD 功能将在后续需求中实现。</Text>
    </div>
  );
}
